import axios from 'axios'
import store from '@/store'
import i18n from '@/languages'
import { getToken } from '@/utils/auth'
import { Msgbox, Message } from "element3";

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['X-Token'] = getToken()
      console.log("axios get token: " + getToken())
    }

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // console.log(res)
    // if the custom code is not 1, it is judged as an error.
    if (res.typeCode === 1) {
      return res
    }

    let message = i18n.global.t("api.error." + res.typeCode);
    if (message === ("api.error." + res.typeCode)) {
      message = "code" + res.typeCode + ": " + res.message;
    }
    if (res.typeCode === 101) {
      // 101: Illegal token;
      Msgbox.confirm(message, i18n.global.t("api.hint." + res.typeCode), {
        confirmButtonText: i18n.global.t("common.sure"),
        cancelButtonText: i18n.global.t("common.cancel"),
        type: 'warning'
      }).then(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
      })
    }
    else {
      Message.error({
        message,
        duration: 5 * 1000
      })
    }

    return Promise.reject(new Error(res.details || 'Error'))
  },
  error => {
    console.log('err' + error) // for debug
    Message.error({
      message: error.message,
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
